import React from "react";
import Carousel from "../components/carousel/Carousel";
import InfoCard from "../components/Info/InfoCard";
import Event from "../components/Events/Event";
import Extra from "../components/Extra/Extra";
import HomeContact from "../components/Extra/HomeContact";
import SchoolInfo from "../components/Info/SchoolInfo";

const Home = () => {
  return (
    <div>
      <Carousel />
      <div className="px-2 md:px-32 py-10">
        <InfoCard />
      </div>
      <Event />
      <Extra />
      <SchoolInfo />
      <HomeContact />
    </div>
  );
};

export default Home;
